import React, { Component } from 'react';
import classNames from 'classnames';
import { Portalify } from '@buyhatke/react-ui';

import { Button } from '../Button';
import { If, Then, Else } from '../IfElse';

import {
	getScrollbarWidth,
	Harpic,
	hasOwn,
	checkDocument,
	getAnimationEndEvent,
} from '@utils/customLib';

class CModal extends Component {
	$modalMain = React.createRef();

	$modalWrap = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			modalOpen: props.openMoi,
		};
		this.closeModalToFocus = React.createRef();
	}

	componentDidMount() {
		if (this.props.openMoi) {
			this.modalOpenerMain();
		}
	}

	componentDidUpdate(prevProps) {
		const { openMoi } = this.props;

		if (prevProps.openMoi !== openMoi) {
			if (openMoi) {
				this.modalOpenerMain();
			} else {
				this.modalCloserMain();
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener('keyup', this.listenToEscape);

		this.enableBodyScroll();
		this.onModalClosedNShutDown();
	}

	enableBodyScroll = () => {
		requestAnimationFrame(() => {
			if (checkDocument && !document.querySelector('.c-modals--open')) {
				const $body = document.body;

				$body.classList.remove('modal-shown');
				// $body.parentElement.classList.remove('modal-shown');
				// if (
				// 	window.innerHeight < $body.offsetHeight &&
				// 	getScrollbarWidth() !== 0
				// ) {
				$body.style.marginRight = '';
				// }
			}
		});
	};

	listenToEscape = e => {
		if (e.keyCode === 27) {
			this.closeThisModal();
		}
	};

	modalMainOpenAnimateEnd = () => {
		const $modalMain = this.$modalMain.current;

		$modalMain.classList.remove('c-modal__main--isOpening');
		$modalMain.removeEventListener(
			getAnimationEndEvent,
			this.modalMainOpenAnimateEnd
		);
		requestAnimationFrame(() => {
			this.onModalOpenedNReady();
		});
	};

	onModalOpenedNReady = () => {
		const { footer } = this.props;
		const { onOpenNReady } = this.props;

		if (typeof onOpenNReady === 'function') {
			onOpenNReady();
		}
		if (checkDocument) {
			document.addEventListener('keyup', this.listenToEscape);
			if (
				Array.isArray(footer) &&
				!footer.some(btn => hasOwn(btn, 'focus')) &&
				this.closeModalToFocus.current &&
				typeof this.closeModalToFocus.current.focus === 'function'
			) {
				// requestAnimationFrame(() => {
				this.closeModalToFocus.current.focus();
				// });
			}
		}
	};

	modalMainCloseAnimateEnd = () => {
		const $modalMain = this.$modalMain.current;

		requestAnimationFrame(() => {
			this.onModalClosedNShutDown();
			this.enableBodyScroll();
			$modalMain.classList.remove('c-modal__main--isClosing');
		});

		$modalMain.removeEventListener(
			getAnimationEndEvent,
			this.modalMainCloseAnimateEnd
		);
		// this.modalCloseTimeout1 = setTimeout(() => {
		// }, 300);
	};

	onModalClosedNShutDown = () => {
		const { openMoi, onCloseNShutDown = () => {} } = this.props;

		if (!openMoi) {
			this.setState(
				{
					modalOpen: false,
				},
				onCloseNShutDown
			);
		}
	};

	modalWrapOpenAnimateEnd = () => {
		const $modalWrap = this.$modalWrap.current;
		const { onModalOpen } = this.props;
		if ($modalWrap) {
			$modalWrap.classList.remove('c-modals--isOpening');
			$modalWrap.removeEventListener(
				getAnimationEndEvent,
				this.modalWrapOpenAnimateEnd
			);
		}
		// callback after modal is opened
		if (typeof onModalOpen === 'function') {
			onModalOpen();
		}
	};

	modalWrapCloseAnimateEnd = () => {
		const $modalWrap = this.$modalWrap.current;

		if ($modalWrap) {
			$modalWrap.classList.remove('c-modals--isClosing');
			$modalWrap.removeEventListener(
				getAnimationEndEvent,
				this.modalWrapCloseAnimateEnd
			);
		}
	};

	disableBodyScroll = () => {
		const $body = document.body;

		if (!$body.classList.contains('modal-shown')) {
			requestAnimationFrame(() => {
				const scrollbarWidth = getScrollbarWidth();

				if (
					window.innerHeight < $body.offsetHeight &&
					scrollbarWidth !== 0
				) {
					$body.style.marginRight = `${scrollbarWidth}px`;
				}
				$body.classList.add('modal-shown');
				// $body.parentElement.classList.add('modal-shown');
			});
		}
	};

	onModalOpening = () => {
		if (this.$modalMain.current) {
			const $modalMain = this.$modalMain.current;

			$modalMain.classList.add('c-modal__main--isOpening');
			if (getAnimationEndEvent) {
				$modalMain.addEventListener(
					getAnimationEndEvent,
					this.modalMainOpenAnimateEnd
				);
			}
		}
		if (this.$modalWrap.current) {
			const $modalWrap = this.$modalWrap.current;

			$modalWrap.classList.add('c-modals--isOpening');
			if (getAnimationEndEvent) {
				$modalWrap.addEventListener(
					getAnimationEndEvent,
					this.modalWrapOpenAnimateEnd
				);
			}
		}
	};

	modalOpenerMain = () => {
		if (checkDocument) {
			this.disableBodyScroll();
		}
		this.setState(
			{
				modalOpen: true,
			},
			this.onModalOpening
		);
	};

	modalCloserMain = () => {
		document.removeEventListener('keyup', this.listenToEscape);

		if (this.$modalMain.current) {
			const $modalMain = this.$modalMain.current;

			$modalMain.classList.add('c-modal__main--isClosing');
			if (getAnimationEndEvent) {
				$modalMain.addEventListener(
					getAnimationEndEvent,
					this.modalMainCloseAnimateEnd
				);
			}
		} else {
			this.enableBodyScroll();
			this.onModalClosedNShutDown();
		}
		if (this.$modalWrap.current) {
			const $modalWrap = this.$modalWrap.current;

			$modalWrap.classList.add('c-modals--isClosing');
			if (getAnimationEndEvent) {
				$modalWrap.addEventListener(
					getAnimationEndEvent,
					this.modalWrapCloseAnimateEnd
				);
			}
		} else {
			this.enableBodyScroll();
			this.onModalClosedNShutDown();
		}
	};

	closeThisModal = () => {
		const { modalClose } = this.props;

		if (typeof modalClose === 'function') {
			modalClose();
		} else {
			this.modalCloserMain();
		}
	};

	render() {
		const {
			footer,
			customFooterLeft,
			openMoi,
			wide,
			small,
			hideHeader,
			header,
			bodyClassName,
			anyHeight,
			main,
			children,
			customFooter,
			customWrapper,
			clickAnywhere = true,
		} = this.props;
		const { modalOpen } = this.state;
		const footerExists = Array.isArray(footer) && footer.length > 0;
		const customFooterExists = typeof customFooter !== 'undefined';
		const customFooterLeftExists = typeof customFooterLeft !== 'undefined';
		const onlyCustomFooterExists =
			customFooterExists && !footerExists && !customFooterLeftExists;

		if (modalOpen) {
			return (
				<Portalify id="modal-container">
					<div
						ref={this.$modalWrap}
						className={`c-modals ${
							openMoi ? 'c-modals--open' : ''
						}`}
					>
						<div
							className="c-modal__bg js-modal__close"
							title="Click Anywhere Here to Close"
							onClick={() =>
								clickAnywhere ? this.closeThisModal() : ''
							}
						/>
						<div
							className={classNames(
								'c-modal__main overflow-hidden flex flex-col',
								// 'slideInDown--center',
								{
									'c-modal--wide': wide,
								},
								{
									'c-modal--small': small,
								},
								{
									/* {
								'flex flex-col': this.props
									.sticky,
							} */
								},
								customWrapper
							)}
							role="dialog"
							aria-modal={openMoi}
							ref={this.$modalMain}
							aria-labelledby={`${
								typeof header === 'string'
									? header
									: 'modal header contents'
							}`}
							aria-describedby={`${
								typeof header === 'string'
									? header
									: 'modal header'
							}`}
						>
							{!hideHeader && (
								<div
									className={`bg-gray-200 text-gray-900 ${
										header
											? 'c-window__header--type2 uppercase'
											: 'c-window__header--mini mt-8'
									} borderBox`}
								>
									{header && (
										<div className="mr-10 js-windowHdr__text js-modal__headerContent">
											{header || 'Header'}
										</div>
									)}

									<button
										className="c-window__close text-gray-500 outline-none focus:outline-none"
										onClick={this.closeThisModal}
										ref={this.closeModalToFocus}
										aria-label="close"
										onKeyUp={e => {
											if (
												e.charCode === 13 ||
												e.charCode === 32
											) {
												this.closeThisModal();
											}
										}}
										type="button"
									>
										&times;
									</button>
								</div>
							)}
							<div
								className={`${
									bodyClassName || 'p-8'
								} c-modal__wrapper ${
									anyHeight
										? ''
										: 'c-modal__wrapper--scrollable'
								}`}
							>
								<div className="js-modal__mainContent">
									<If condition={typeof main === 'string'}>
										<Then>
											<div
												dangerouslySetInnerHTML={{
													__html: Harpic(main),
												}}
											/>
										</Then>
										<Else>
											<If
												condition={
													typeof main !== 'undefined'
												}
											>
												<Then>{main}</Then>
												<Else>{children}</Else>
											</If>
										</Else>
									</If>
								</div>
							</div>
							<If condition={onlyCustomFooterExists}>
								<Then>{customFooter}</Then>
								<Else>
									<If
										condition={
											footerExists ||
											customFooterExists ||
											customFooterLeftExists
										}
									>
										<Then>
											<div
												className={`c-modal__footerContent js-modal__footerContent flex ${
													(footerExists && 'pb-4') ||
													''
												}`}
											>
												{customFooterLeftExists && (
													<div className="flex justify-start flex-row flex-wrap items-start mr-4">
														{customFooterLeft}
													</div>
												)}
												<div className="flex ml-auto justify-end flex-row flex-wrap items-start">
													{customFooter}
													{footerExists &&
														Array.from(footer).map(
															(item, index) => {
																const isLastItem =
																	footer.length ===
																	index + 1;
																const isFirstItem =
																	index === 0;

																switch (
																	item.type
																) {
																	case 'close':
																		return (
																			<Button
																				key={
																					item.text
																				}
																				link={
																					item.link ||
																					null
																				}
																				href={
																					item.href ||
																					null
																				}
																				color={
																					item.color ||
																					null
																				}
																				className={`js-modal__close c-btn--size2 ${
																					(!isFirstItem &&
																						'ml-4') ||
																					''
																				} ${
																					(!isLastItem &&
																						'mb-4 sm:mb-0 ') ||
																					''
																				}`}
																				variant={
																					item.variant ||
																					(!item.color &&
																						'minimal')
																				}
																				focus={
																					item.focus
																				}
																				onClick={() => {
																					if (
																						typeof item.fn ===
																						'function'
																					) {
																						item.fn();
																					}
																					this.closeThisModal();
																				}}
																				rel={
																					item.rel ||
																					null
																				}
																				target={
																					item.target ||
																					null
																				}
																				form={
																					item.form
																				}
																				triangle={
																					item.triangle ||
																					null
																				}
																				disabled={
																					item.disabled
																				}
																			>
																				{item.text ||
																					'Close'}
																			</Button>
																		);
																	default:
																		return (
																			<Button
																				key={
																					item.text
																				}
																				color={
																					item.color ||
																					null
																				}
																				variant={
																					item.variant ||
																					(!item.color &&
																						'minimal')
																				}
																				triangle={
																					item.triangle ||
																					null
																				}
																				className={classNames(
																					{
																						'js-modal__close':
																							item.action ===
																							'close',
																					},
																					'c-btn--size2',
																					{
																						'mb-4 sm:mb-0':
																							!isLastItem,
																					},
																					{
																						'ml-4': !isFirstItem,
																					}
																				)}
																				focus={
																					item.focus
																				}
																				onClick={() => {
																					if (
																						typeof item.fn ===
																						'function'
																					) {
																						item.fn();
																					}
																				}}
																				link={
																					item.link ||
																					null
																				}
																				href={
																					item.href ||
																					null
																				}
																				rel={
																					item.rel ||
																					null
																				}
																				target={
																					item.target ||
																					null
																				}
																				form={
																					item.form
																				}
																				disabled={
																					item.disabled
																				}
																			>
																				{
																					item.text
																				}
																			</Button>
																		);
																}
															}
														)}
												</div>
											</div>
										</Then>
									</If>
								</Else>
							</If>
						</div>
					</div>
				</Portalify>
			);
		}
		return <Portalify id="modal-container" />;
	}
}

export default CModal;
